import ModuleBreadCrumb from "../../../components/breadCrumb";
import ModuleTitle from "../../../components/common/title";
import { option_category_obj } from "../../../service/option";

export default function MemberSettingSecurity() {
  const crumbItem = [
    { key: 1, label: "首頁", href: "/member" },
    { key: 2, label: "系統相關", href: "/member/setting" },
    { key: 3, label: option_category_obj.setting.security.label },
  ];

  return (
    <>
      <ModuleBreadCrumb crumbItem={crumbItem} />

      <ModuleTitle
        data={{ title: option_category_obj.setting.security.label }}
      />

      <div className="text-xl line-height-4">
        歡迎您參加運用長庚護心網站(以下簡稱本網站)進行遠距心臟復健的研究。本網站對於您個人資料之蒐集、處理及利用，研究團隊將依研究參與者同意書、人體研究相關法規及個人資料保護法相關規定辦理，並善盡資料保存及運用的責任，確保資料的隱密與安全性。
      </div>
    </>
  );
}
